(function () {
  /**
   * ADR-202 — «إضافة للطلب» on the web, the same flow as the app's
   * order-add session (orderAddSessionProvider / startOrderAddCheckout):
   *
   * 1. The order page (eros-account-orders.js) calls ErosOrderAdd.start(order)
   *    for an addable order → session in localStorage, the store opens.
   * 2. While the session is active: a strip at the top of every page, and
   *    in the cart (drawer + /cart) a banner and «إرسال الإضافة» in place of
   *    the checkout swipe bar.
   * 3. Submit → POST /v1/orders/add-lines with the cart lines → the sent
   *    lines leave the Shopify cart, the session ends, the order opens.
   *
   * The order's existing lines are NOT put into the web cart (it is
   * Shopify's own cart — they would be sent again); the banner names the
   * order instead. Gift cards are refused before calling the server (which
   * refuses them too: gift_credit_not_addable).
   */

  var KEY = 'eros_order_add';
  var MAX_AGE_MS = 24 * 60 * 60 * 1000;
  var STR = (window.ErosAccountStrings && window.ErosAccountStrings.orders) || {};

  function t(key, fallback, vars) {
    var s = STR[key] || fallback;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(String(vars[k]));
      });
    }
    return s;
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || !s.orderGid || Date.now() - (s.startedAt || 0) > MAX_AGE_MS) {
        window.localStorage.removeItem(KEY);
        return null;
      }
      return s;
    } catch (_) {
      return null;
    }
  }

  function write(s) {
    try {
      if (s) window.localStorage.setItem(KEY, JSON.stringify(s));
      else window.localStorage.removeItem(KEY);
    } catch (_) {
      // Private mode: the session simply does not survive navigation.
    }
    paint();
  }

  /**
   * «#199120704رقم الطلب» → «#199120704»: the store's Shopify order names
   * carry a text suffix, which read badly inside «للطلب {orderName}».
   */
  function shortName(name) {
    var m = /#\s*\d+/.exec(String(name || ''));
    return m ? m[0].replace(/\s+/g, '') : String(name || '');
  }

  function active() {
    return !!read() && !!(window.ErosSession && window.ErosSession.isSignedIn());
  }

  function start(order) {
    write({
      orderGid: order.idGid,
      orderName: order.orderNameDisplay || '',
      startedAt: Date.now(),
    });
    window.ErosUI.toast(t('order_add_started', 'اختر المنتجات من المتجر ثم أرسلها من السلة'), 'info');
    window.location.href = '/';
  }

  function cancel() {
    write(null);
  }

  // --- UI: strip on every page, banner + submit in every cart footer ---

  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show();
    else window.location.href = '/cart';
  }

  function buildStrip(session) {
    var strip = window.ErosUI.el('div', 'eros-order-add-strip', { 'data-eros-order-add-strip': '' });
    var label = window.ErosUI.el('span', 'eros-order-add-strip__label');
    label.textContent = t('order_add_strip', 'تضيف منتجات للطلب {orderName}', { orderName: shortName(session.orderName) });
    var openBtn = window.ErosUI.el('button', 'eros-order-add-strip__action', { type: 'button' });
    openBtn.textContent = t('order_add_open_cart', 'فتح السلة');
    openBtn.addEventListener('click', openCart);
    var cancelBtn = window.ErosUI.el('button', 'eros-order-add-strip__action', { type: 'button' });
    cancelBtn.textContent = t('order_add_cancel', 'إلغاء');
    cancelBtn.addEventListener('click', cancel);
    strip.appendChild(label);
    strip.appendChild(openBtn);
    strip.appendChild(cancelBtn);
    return strip;
  }

  function buildCartBlock(session) {
    var block = window.ErosUI.el('div', 'eros-order-add-cart', { 'data-eros-order-add-cart': '' });
    var banner = window.ErosUI.el('div', 'eros-order-add-cart__banner');
    var text = window.ErosUI.el('span');
    text.textContent = t('order_add_banner', 'أضف منتجاتك الجديدة للطلب {orderName}', { orderName: shortName(session.orderName) });
    var cancelBtn = window.ErosUI.el('button', 'eros-order-add-cart__cancel', { type: 'button' });
    cancelBtn.textContent = t('order_add_cancel', 'إلغاء');
    cancelBtn.addEventListener('click', cancel);
    banner.appendChild(text);
    banner.appendChild(cancelBtn);
    var submit = window.ErosUI.el('button', 'button w-full', { type: 'button', 'data-eros-order-add-submit': '' });
    submit.textContent = t('order_add_submit', 'إرسال الإضافة');
    submit.addEventListener('click', function () {
      submitAdd(submit);
    });
    block.appendChild(banner);
    block.appendChild(submit);
    return block;
  }

  var painting = false;
  function paint() {
    if (painting) return;
    painting = true;
    try {
      var session = active() ? read() : null;
      document.documentElement.classList.toggle('eros-order-add-active', !!session);

      var strip = document.querySelector('[data-eros-order-add-strip]');
      if (!session && strip) strip.remove();
      if (session && !strip) {
        var host = document.querySelector('main') || document.body;
        host.insertBefore(buildStrip(session), host.firstChild);
      }

      // Every checkout CTA (drawer + /cart). The cart sections re-render on
      // each change, so this runs again from the observer below.
      document.querySelectorAll('.eros-fswipe-cta').forEach(function (cta) {
        var mine = cta.parentNode && cta.parentNode.querySelector('[data-eros-order-add-cart]');
        if (!session && mine) mine.remove();
        if (session && !mine) cta.parentNode.insertBefore(buildCartBlock(session), cta);
      });
    } finally {
      painting = false;
    }
  }

  // --- Submit ---

  function errorMessage(code) {
    switch (code) {
      case 'gift_credit_not_addable':
        return t('order_add_gift_refused', 'بطاقات الرصيد لا تُضاف لطلب سابق — اشترِها بطلب جديد');
      case 'not_addable_prepared':
        return t('add_blocked_prepared', 'تم تدقيق طلبك وبدأ تجهيزه — للإضافة أنشئ طلباً جديداً أو تواصل معنا عبر واتساب');
      case 'not_addable_legacy':
        return t('add_blocked_legacy', 'لا يمكن الإضافة إلى هذا الطلب القديم — أنشئ طلباً جديداً');
      case 'not_addable_paid':
        return t('add_blocked_paid', 'الطلب مدفوع إلكترونياً — للإضافة أنشئ طلباً جديداً أو تواصل معنا عبر واتساب');
      case 'already_cancelled':
        return t('add_blocked_cancelled', 'هذا الطلب ملغى — لا يمكن الإضافة إليه، أنشئ طلباً جديداً');
      case 'not_addable_fulfillment':
      case 'order_edit_not_allowed':
        return t('add_blocked_courier', 'لا يمكن إضافة منتجات — الطلب في طريقه إلى شركة التوصيل');
      case 'invalid_variant_gid':
      case 'invalid_quantity':
      case 'lines_required':
        return t('order_add_empty', 'أضف منتجاً واحداً على الأقل قبل الإرسال');
      default:
        return t('order_add_failed', 'تعذّر إرسال الإضافة، حاول مرة أخرى');
    }
  }

  /** The order no longer takes additions: the session has nothing left to do. */
  var SESSION_ENDING = {
    not_addable_prepared: true,
    not_addable_legacy: true,
    not_addable_paid: true,
    already_cancelled: true,
    not_addable_fulfillment: true,
    order_edit_not_allowed: true,
    order_not_found: true,
    order_not_owned: true,
  };

  function giftConfig() {
    return window.ErosGiftCredit ? window.ErosGiftCredit.config().catch(function () { return null; }) : Promise.resolve(null);
  }

  var submitting = false;
  function submitAdd(button) {
    var session = read();
    if (!session || submitting) return;
    submitting = true;
    document.querySelectorAll('[data-eros-order-add-submit]').forEach(function (b) {
      b.disabled = true;
    });

    function done() {
      submitting = false;
      document.querySelectorAll('[data-eros-order-add-submit]').forEach(function (b) {
        b.disabled = false;
      });
    }

    Promise.all([fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), giftConfig()])
      .then(function (res) {
        var cart = res[0];
        var cfg = res[1];
        var items = (cart && cart.items) || [];
        if (!items.length) {
          window.ErosUI.toast(t('order_add_empty', 'أضف منتجاً واحداً على الأقل قبل الإرسال'), 'error');
          done();
          return;
        }
        if (cfg && window.ErosGiftCredit && items.some(function (i) { return window.ErosGiftCredit.isGiftVariant(cfg, i.variant_id); })) {
          window.ErosUI.toast(errorMessage('gift_credit_not_addable'), 'error');
          done();
          return;
        }
        var lines = items.map(function (i) {
          return { variantGid: 'gid://shopify/ProductVariant/' + i.variant_id, quantity: i.quantity };
        });
        var sentKeys = items.map(function (i) {
          return i.key;
        });
        return window.ErosCommerce.addOrderLines(session.orderGid, lines).then(function () {
          // Only what was sent leaves the cart; anything added since stays.
          var updates = {};
          sentKeys.forEach(function (k) {
            updates[k] = 0;
          });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          })
            .catch(function () {})
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              write(null);
              window.ErosUI.toast(t('order_add_success', 'تمت إضافة المنتجات إلى طلبك'), 'info');
              var id = String(session.orderGid).split('/').pop();
              window.location.href = '/pages/account-orders#order=' + encodeURIComponent(id);
            });
        });
      })
      .catch(function (err) {
        var code = err && err.code;
        var blocked = window.ErosCommerce.customerBlocked(err); // ADR-301
        if (blocked) {
          window.ErosUI.toast(blocked.message, 'error', { href: blocked.contactUrl, label: t('contact_us', 'تواصل معنا') });
          done();
          return;
        }
        window.ErosUI.toast(errorMessage(code), 'error');
        if (code && SESSION_ENDING[code]) write(null);
        done();
      });
  }

  // --- Boot ---

  function boot() {
    if (!window.ErosUI) return;
    paint();
    // Cart sections swap their HTML on every change; re-attach our block.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled || painting) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        paint();
      });
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) paint();
    });
    if (window.ErosSession && typeof window.ErosSession.onChange === 'function') {
      window.ErosSession.onChange(function () {
        if (!window.ErosSession.isSignedIn()) cancel();
        else paint();
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.ErosOrderAdd = { start: start, cancel: cancel, active: active, submit: function () { submitAdd(null); } };
})();
